import React from "react";
import { Alert, Container, LinearProgress, Stack } from "@mui/material";
import Grid2 from "@mui/material/Grid2";

import CustomerDialog from "./customer-management/CustomerDialog";
import CustomerEmptyState from "./customer-management/CustomerEmptyState";
import CustomerGroupList from "./customer-management/CustomerGroupList";
import CustomerHeader from "./customer-management/CustomerHeader";
import CustomerToast from "./customer-management/CustomerToast";
import CustomerToolbar from "./customer-management/CustomerToolbar";
import DeleteCustomerDialog from "./customer-management/DeleteCustomerDialog";
import useCustomerManagement from "./customer-management/useCustomerManagement";

export default function CustomerManagement() {
    const {
        openDialog,
        customerList,
        currentCustomer,
        editingIndex,
        deleteAsk,
        query,
        sortBy,
        loading,
        err,
        toast,
        fieldErrors,
        taxErrors,
        addressErrors,
        bankErrors,
        taxNumberError,
        vatIdError,
        filteredSorted,
        groupedCustomers,
        customerIndexById,
        setQuery,
        setSortBy,
        setToast,
        setDeleteAsk,
        fetchCustomers,
        handleDialogOpen,
        handleDialogClose,
        handleEdit,
        handleSave,
        handleDeleteAsk,
        handleDeleteConfirm,
        handleCustomerFieldChange,
        onAddressChange,
        onBankChange,
        onTaxChange,
    } = useCustomerManagement();

    return (
        <>
            <CustomerHeader onRefresh={fetchCustomers} onAdd={handleDialogOpen} />

            <Container maxWidth="lg" sx={{ mt: 4, pb: 6 }}>
                <Stack spacing={3}>
                    <CustomerToolbar
                        query={query}
                        sortBy={sortBy}
                        onQueryChange={setQuery}
                        onSortChange={setSortBy}
                    />

                    {loading && <LinearProgress />}

                    {!loading && err && <Alert severity="error">{err}</Alert>}

                    {!loading && !err && filteredSorted.length === 0 && (
                        <Grid2 container spacing={2}>
                            <Grid2 xs={12}>
                                <CustomerEmptyState onAdd={handleDialogOpen} />
                            </Grid2>
                        </Grid2>
                    )}

                    {!loading && !err && filteredSorted.length > 0 && (
                        <CustomerGroupList
                            groups={groupedCustomers}
                            customerIndexById={customerIndexById}
                            customerList={customerList}
                            onEdit={handleEdit}
                            onDeleteAsk={handleDeleteAsk}
                        />
                    )}
                </Stack>
            </Container>

            <CustomerDialog
                open={openDialog}
                onClose={handleDialogClose}
                onSave={handleSave}
                editingIndex={editingIndex}
                currentCustomer={currentCustomer}
                fieldErrors={fieldErrors}
                taxErrors={taxErrors}
                taxNumberError={taxNumberError}
                vatIdError={vatIdError}
                addressErrors={addressErrors}
                bankErrors={bankErrors}
                onFieldChange={handleCustomerFieldChange}
                onTaxChange={onTaxChange}
                onAddressChange={onAddressChange}
                onBankChange={onBankChange}
            />

            <DeleteCustomerDialog
                open={Boolean(deleteAsk)}
                customer={deleteAsk?.cust}
                onClose={() => setDeleteAsk(null)}
                onConfirm={handleDeleteConfirm}
            />

            <CustomerToast toast={toast} onClose={() => setToast((prev) => ({ ...prev, open: false }))} />
        </>
    );
}
